<template>
  <q-icon
    :name="isCustomIcon ? undefined : name"
    v-bind="$attrs"
  >
    <component
      :is="icon"
      v-if="isCustomIcon"
    />

    <q-badge
      v-if="indicator"
      floating
      color="red"
      rounded
    />
  </q-icon>
</template>

<script setup lang="ts">
import type { Component } from 'vue'
import { computed, defineAsyncComponent } from 'vue'

const { name, indicator } = defineProps<{
  name: string
  indicator?: boolean
}>()

const iconModules = import.meta.glob<Component>('@/assets/icons/**/*.svg', {
  query: '?component',
  import: 'default',
})

const isCustomIcon = computed(() => name?.startsWith('ic-'))

const icon = computed(() => {
  // Find matching icon path
  const matchingPath = Object.keys(iconModules).find(path => path.endsWith(`/${name}.svg`))

  if (!matchingPath) {
    console.warn(`[ReSvgIcon] Icon not found: ${name}`)
    return null
  }

  return defineAsyncComponent(() => iconModules[matchingPath]())
})
</script>
